import React, { type CSSProperties } from 'react';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { Box } from '../box';
import type { ImageT } from '../image';

export type ImageStretchT = ImageT;

const ImageStretch = ({ src, alt }: ImageStretchT) => {
  return (
    <Box
      role={alt === '' ? undefined : 'img'}
      aria-label={alt}
      style={
        {
          '--image-stretch-image-url': `url(${src})`,
        } as CSSProperties
      }
      className={clsx([
        'w-full',
        'h-full',
        'bg-center',
        'bg-no-repeat',
        'bg-contain',
        'bg-(image:--image-stretch-image-url)',
      ])}
    />
  );
};

export { ImageStretch };
